import React from 'react';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

function Cookies() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>{t('cookiesPage.title')}</h1>
        <p className="last-updated">{t('cookiesPage.lastUpdated')}: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>{t('cookiesPage.what.title')}</h2>
          <p>{t('cookiesPage.what.text')}</p>
        </section>

        <section>
          <h2>{t('cookiesPage.types.title')}</h2>
          <h3>{t('cookiesPage.types.essential.title')}</h3>
          <p>{t('cookiesPage.types.essential.text')}</p>
          
          <h3>{t('cookiesPage.types.analytics.title')}</h3>
          <p>{t('cookiesPage.types.analytics.text')}</p>
          
          <h3>{t('cookiesPage.types.advertising.title')}</h3>
          <p>{t('cookiesPage.types.advertising.text')}</p>
        </section>

        <section>
          <h2>{t('cookiesPage.manage.title')}</h2>
          <p>{t('cookiesPage.manage.text')}</p>
          <button 
            className="cookie-settings-btn"
            onClick={() => {
              localStorage.removeItem('cookieConsent');
              window.location.reload();
            }}
          >
            {t('cookiesPage.manage.button')}
          </button>
        </section>

        <section>
          <h2>{t('cookiesPage.thirdParty.title')}</h2>
          <p>{t('cookiesPage.thirdParty.text')}</p>
          <ul>
            <li><strong>Google AdSense:</strong> {t('cookiesPage.thirdParty.google')}</li>
            <li><strong>Google Analytics:</strong> {t('cookiesPage.thirdParty.analytics')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('cookiesPage.more.title')}</h2>
          <p>{t('cookiesPage.more.text')}</p>
          <p>
            <a href="/privacy">{t('cookiesPage.more.link')}</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default Cookies;
